module.exports = "1. 这是说明信息\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/specTracker/specTracker-20.txt
// module id = G7++
// module chunks = 2